export default __webpack_public_path__ + "static/media/d18.d95cc4c4.png";